import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import type { RingFinish, RingStyle } from '@/app/types/ring';
import type { ListProduct } from '@/queries/Products';

import { OUT_OF_STOCK } from '../_consts';
import type { Ring } from '../_hooks/types';
import type { UseProductsInventory } from '../_hooks/useProductsInventory';

export const OR4_HANDLE_PARTIAL = 'or4';

export interface FilterByInStockReturn {
  filteredStyleByInStock: Ring[] | undefined;
  filteredFinishByInStock: Ring[] | undefined;
}

export interface FilterByInStockProps {
  productsData: ListProduct[] | undefined;
  isOuraRing4Wizard: boolean;
  getStyleStockStatus: UseProductsInventory['getStyleStockStatus'];
  getFinishStockStatus: UseProductsInventory['getFinishStockStatus'];
}

const filterByInStock = ({
  productsData,
  isOuraRing4Wizard,
  getStyleStockStatus,
  getFinishStockStatus,
}: FilterByInStockProps): FilterByInStockReturn => {
  const ringsData: ListProduct[] | undefined = productsData?.filter(
    (product: ListProduct) => product.isRing,
  );

  const oR4RingsData = ringsData?.filter((product: ListProduct) =>
    product.handle.includes(OR4_HANDLE_PARTIAL),
  );

  const gen3RingsData = ringsData?.filter(
    (product: ListProduct) => !product.handle.includes(OR4_HANDLE_PARTIAL),
  );

  const _ringsData = isOuraRing4Wizard ? oR4RingsData : gen3RingsData;

  const rings: Ring[] | undefined = _ringsData?.map((product: ListProduct) => {
    // split at first hyphen only
    const [style, ...rest] = product.handle.split(/-(.*)/);

    const _style =
      style === OR4_HANDLE_PARTIAL
        ? RingStyleEnum.OuraRing4
        : (style as RingStyle);
    const _finish = rest.join('') as RingFinish;

    return { ...product, style: _style, finish: _finish };
  });

  const filteredStyleByInStock: Ring[] | undefined = rings?.filter((ring) => {
    if (
      !ring.style ||
      ring.style.includes('test') ||
      ring.style.includes('recurring')
    )
      return false;
    return (
      getStyleStockStatus({
        style: ring.style,
        isOuraRing4: isOuraRing4Wizard,
      }) !== OUT_OF_STOCK
    );
  });

  const filteredFinishByInStock: Ring[] | undefined =
    filteredStyleByInStock?.filter((ring) => {
      if (!ring.finish || !ring.style) return false;
      return (
        getFinishStockStatus({
          style: ring.style,
          finish: ring.finish,
          isOuraRing4: isOuraRing4Wizard,
        }) !== OUT_OF_STOCK
      );
    });

  return {
    filteredStyleByInStock,
    filteredFinishByInStock,
  };
};

export default filterByInStock;
